const visileColumns = [
    {
      title: "Department",
      field: "DepartmentName",
      locked: false,
      filter: "text",
      width: "auto",
      show: true,
    },
    {
      title: "Point Of Contact",
      field: "EmployeeName",
      locked: false,
      filter: "text",
      width: "200",
      show: true,
    },
    {
        title: "Active",
        field: "IsActive",
        locked: false,
        filter: "boolean",
        width: "180",
        show: true,
        cell: (props) => (
            <td>{props.dataItem[props.field] ? "Yes" : "No"}</td>
          ),
      },
    {
      title: "Assigned On",
      field: "Assignedon",
      locked: false,
      filter: "date",
      format: "MM/DD/YYYY",
      editor: "date",
      width: "180",
      show: true,
    },
    {
      title: "Updated On",
      field: "Updated_On",
      locked: false,
      filter: "date",
      format: "MM/DD/YYYY",
      editor: "date",
      width: "180",
      show: true,
      
    },
    // {
    //   title: "Requirements",
    //   field: "REQUIREMENTS",
    //   locked: false,
    //   filter: "text",
    //   width: "auto",
    //   show: true,
    // },
    // {
    //   title: "Date Entered",
    //   field: "DATE_ENTERED",
    //   locked: false,
    //   filter: "date",
    //   format: "MM/DD/YYYY",
    //   editor: "date",
    //   width: "180",
    //   show: true,
    // },
    // {
    //   title: "Announcement Type",
    //   field: "ANNOUNCEMENT_TYPE",
    //   locked: false,
    //   filter: "text",
    //   width: "200",
    //   show: true,
    // },
  ];
  
  export default visileColumns;
  